// Microphone → 0..1 voice level
const aiAssistantAudioLevelConfig = {
    // ~21 ms at 48 kHz: short enough to follow a syllable, long enough for a stable RMS
    FFT_SIZE: 1024,
    // dBFS window mapped to 0..1 - narrow on purpose, or normal speech hovers mid-range and looks unresponsive
    SILENCE_DBFS: -48,
    LOUD_DBFS: -24,
    // Noise floor; also avoids log10(0)
    SILENT_RMS: 0.00001,
    // Time to ~63% of the target: fast attack to hit syllables, slow release to avoid flicker
    ATTACK_S: 0.035,
    RELEASE_S: 0.22,
};

export default aiAssistantAudioLevelConfig;
